export function offerCountLabel(count: number | null, isApplicationMode: boolean): string {
  if (!count) {
    return isApplicationMode ? 'Be the first to apply!' : 'Be the first to offer!'
  }
  if (isApplicationMode) {
    return `${count} ${count === 1 ? 'application' : 'applications'}`
  }
  return `${count} ${count === 1 ? 'offer' : 'offers'}`
}
